import React, { useEffect, useState } from "react";

import * as S from "./styles";
import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faCoin } from "@fortawesome/pro-light-svg-icons";
import { Text, Title } from "../../main-styles";
import Stepper from "../../../components/Stepper";
import { useNavigate } from "react-router";
import { getUserOrders } from "../../../api/orders";

function Pedidos() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pedidos, setPedidos] = useState([]);

  useEffect(() => {
    loadPedidos();
  }, []);
  async function loadPedidos() {
    try {
      let npedidos = await getUserOrders();
      console.log("npedidos", npedidos);
      setPedidos(npedidos);
    } catch (error) {
      console.error("Error loading pedidos:", error);
    } finally {
      setLoading(false);
    }

  }

  function irParaPedido(id) {
    navigate(`/pedidos/${id}`);
  }
  return (
    <S.Container>
      <Title>Meus Pedidos</Title>
      {pedidos.sort((a, b) => {
        return moment(b.data).diff(moment(a.data));
      }).map((pedido) => (
        <Pedido
          key={pedido.id}
          pedido={pedido}
          onClick={() => irParaPedido(pedido.id)}
        />
      ))}
      {loading && <Text>Carregando pedidos...</Text>}
      {!loading && pedidos.length === 0 && (
        <Text>Você ainda não fez nenhum pedido.</Text>
      )}
    </S.Container>
  );
}

function Pedido({ pedido, onClick }) {
  console.log("Pedido", pedido);
  return (
    <S.PedidoContainer onClick={onClick}>
      <S.PedidoHeader>
        <S.PedidoId>Pedido #{pedido.id}</S.PedidoId>
        <Stepper step={pedido.current_status} />
        <S.PedidoBody>
          <S.PedidoValor>
            <FontAwesomeIcon icon={faCoin} />
            {pedido.value}
          </S.PedidoValor>
          <S.PedidoItens>{pedido.quantidade} itens</S.PedidoItens>
          <S.PedidoData>{pedido.data}</S.PedidoData>
          <FontAwesomeIcon icon={faChevronRight} />
        </S.PedidoBody>
      </S.PedidoHeader>
    </S.PedidoContainer>
  );
}

export default Pedidos;
